// extracted by mini-css-extract-plugin
module.exports = {"hamburgerHelper":"src-components-SiteHeader-HamburgerHelper-styles___hamburgerHelper","white":"src-components-SiteHeader-HamburgerHelper-styles___white"};